import { z } from 'zod';
import { FlowWithDefinitionsSchema, FlowWithOptionalRunStatsSchema } from './flow.js';
import { FlowCreateBodySchema, FlowFindAllQueryParamsSchema, FlowIdParamsSchema, FlowUpdateBodySchema, GetFlowByIdQueryParamsSchema, } from './flowRequests.js';
import { FlowListResponseSchema, FlowListV2QuerySchema } from './list.js';
const TAGS = ['Flow'];
export const FLOWS_BASE_ROUTE = '/flows';
export const FlowCreateRoute = {
    method: 'post',
    fullPath: FLOWS_BASE_ROUTE,
    summary: 'Create a flow',
    tags: TAGS,
    body: FlowCreateBodySchema,
};
export const FlowListRoute = {
    method: 'get',
    fullPath: FLOWS_BASE_ROUTE,
    summary: 'List flows',
    tags: TAGS,
    query: FlowFindAllQueryParamsSchema.strict(),
    response: z.array(FlowWithOptionalRunStatsSchema),
};
export const FlowListV2Route = {
    method: 'get',
    fullPath: '/v2/flows',
    summary: 'List flows',
    description: 'Searches standard flows the caller can access and returns a bounded page of concise summaries. Pass nextCursor as cursor to continue paging, and request a count only when its database cost is useful. Skills and flow templates have different visibility rules and are not returned.',
    tags: TAGS,
    query: FlowListV2QuerySchema,
    response: FlowListResponseSchema,
};
export const FlowGetRoute = {
    method: 'get',
    fullPath: `${FLOWS_BASE_ROUTE}/:id`,
    summary: 'Get a flow and its definition metadata by id',
    description: 'Returns one accessible flow and metadata for its flow-definition versions without executable block graphs. Always set flowDefinitionLimit to bound the response, and set flowDefinitionOrderDirection when version order matters. Retrieve a selected definition by its id to load its complete graph. flow.liveDefinitionId identifies the published definition and may differ from the latest version.',
    tags: TAGS,
    params: FlowIdParamsSchema,
    query: GetFlowByIdQueryParamsSchema.strict(),
    response: FlowWithDefinitionsSchema,
};
export const FlowUpdateRoute = {
    method: 'patch',
    fullPath: `${FLOWS_BASE_ROUTE}/:id`,
    summary: 'Update a flow',
    tags: TAGS,
    params: FlowIdParamsSchema,
    body: FlowUpdateBodySchema,
};
//# sourceMappingURL=routes.js.map